export const typography = {
    allVariants:{
        fontFamily: "'Montserrat', serif",
        lineHeight: 1.5
    },
    h1: {
        fontSize: "3.8rem",
        fontWeight: 700
    },
    h2: {
        fontSize: "3rem",
        fontWeight: 800
    },
    h3: {
        fontSize: "2.1rem",
        fontWeight: 800
    },
    h4: {
        fontSize: "1.5rem"
    },
    h5: {
        fontSize: "1.25rem"
    },
    h6: {
        fontSize: "1rem",
        fontWeight: 720
    },
    body1: {
        fontSize: "1rem"
    },
    body2: {
        fontSize: "0.83rem"
    }
}
